
export enum SignType {
  digital,
  handWritten
}

export interface SignatureDto {

  signatureTimeStamp: Date | undefined;
  signatureSwitch: boolean;
  signatureBase64: string | null;
  signatureMimeType: string | null;
  signed: boolean;

  signatureTypeId: number;

  // signature type
  uiSignatureType: SignType | 'digital' | 'handWritten';
  uiName: string;
  uiDescription: string;
  uiDescriptionHTML: string;
  uiHyperlink: string;

  // check whether signature is read-only
  readOnly: boolean;
  hasDocument: boolean;

}


export interface EndUserSignatureOverviewDto {
  missingSignatures: boolean;

  signatures: SignatureDto[];

}
